import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { wapiRepositoryBuilder } from './WapiRepository'

export const userApiRepository = () => wapiRepositoryBuilder({
  httpService: new AxiosHttpServiceBuilder()
})
